exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".editQuestionComponent{position:relative;padding:1rem 1rem 2.5rem}.editQuestionComponent .row>*{padding-top:0;padding-bottom:0}.editQuestionComponent .v-list-item__content{padding:16px 0}", ""]);

// exports
